<template>
  <v-app>
    <app-header />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from './layouts/appHeader.vue'
export default {
  name: 'App',

  data: () => ({
    //
  }),
  components: {
    AppHeader
  }
};
</script>
<style>
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: right;
  color: #2c3e50;
  box-sizing: border-box;
}

body {
  font-size: 16px;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Rajdhani';
}

.tabCell {
  width: 70px;
  border-bottom: 0.5px solid grey;
  font-size: 0.9em;
}

.border {
  width: 55px;
  border-top: .5px solid #ccc;
  border-left: .5px solid #ccc;
  border-right: .5px solid #ccc;
  border-radius: 3px;
}

.total {
  font-size: 0.9em;
  font-weight: bold;
}

/* for error-message, hint in v-text-field */
.v-messages__message {
	font-size: 1.15em;
	line-height: 1.19em;
}
/* only for hint in v-text-field */
.theme--light.v-messages {
	color: #1A237E;
}
</style>
